import { cn } from '@/lib/utils';

/** Bom = verde; ruim / precisa atenção = vermelho; neutro = cor padrão do tema. */
export type DiretoriaKpiTone = 'good' | 'bad' | 'neutral';

export function diretoriaToneTextClass(tone?: DiretoriaKpiTone): string {
  if (tone === 'good') return 'text-emerald-600 dark:text-emerald-400';
  if (tone === 'bad') return 'text-red-600 dark:text-red-400';
  return 'text-foreground';
}

export function diretoriaKpiValueClass(tone?: DiretoriaKpiTone, extra?: string): string {
  return cn('tabular-nums', diretoriaToneTextClass(tone), extra);
}

/** Cor de traço / preenchimento para sparklines alinhada ao KPI principal. */
export function diretoriaSparklineStroke(tone?: DiretoriaKpiTone): string {
  if (tone === 'good') return '#16a34a';
  if (tone === 'bad') return '#dc2626';
  return 'hsl(222 47% 18%)';
}
